import { API_URL, MOKA_SERVICE_HOST } from 'api/constants';

const MOKA_BUSINESS_SERVICE = `${MOKA_SERVICE_HOST}/business-service`;

/**
 * @return {string}
 */
export function OUTLET_BY_ID(outletId) {
  return `${API_URL}/v1/outlets/${outletId}`;
}

/**
 * @return {string}
 */
export function OUTLET_BY_ID_BUSINESS_SERVICE(outletId) {
  return `${MOKA_BUSINESS_SERVICE}/v3/businesses/outlets/${outletId}`;
}

export const OUTLETS_SEARCH = `${API_URL}/v1/outlets/search`;

export const OUTLET_NEW = `${API_URL}/v1/outlets/new`;

export const UPDATE_SELECTED_OUTLET = `${API_URL}/v2/login/outlets`;

export const OUTLETS_URL = `${API_URL}/v1/outlets`;

export const OUTLET_PRICE = `${API_URL}/v1/billings/outlet_price`;

export const OUTLET_LIST = `${MOKA_BUSINESS_SERVICE}/v3/businesses/outlets`;

export const SAUDAGAR_OUTLET_LIST = `${MOKA_BUSINESS_SERVICE}/v4/businesses/outlets`;

export function SAUDAGAR_OUTLET_BY_ID(outletId) {
  return `${SAUDAGAR_OUTLET_LIST}/${outletId}`;
}
